import FindAutocompleteItemApiModel from './find-autocomplete-item.api-model';
import type { IFindAutocompleteItem } from './find-autocomplete-item.model';

export default class FindAutocompleteApiModel {
  public static mapToBusinessModel(apiModel: FindAutocompleteApiModel): IFindAutocompleteItem[] {
    return apiModel.hits.map((h) => FindAutocompleteItemApiModel.mapToBusinessModel(h));
  }

  public status!: string;
  public hits!: FindAutocompleteItemApiModel[];
}
